import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-column p-3" }
const _hoisted_2 = { class: "d-flex justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PatientDocuments = _resolveComponent("PatientDocuments")!
  const _component_FormSection = _resolveComponent("FormSection")!

  return (_openBlock(), _createBlock(_component_FormSection, {
    title: `Documents for ${_ctx.referral.lastName}, ${_ctx.referral.firstName} `,
    "full-height": false,
    "show-product-pill": true,
    "application-id": _ctx.referral.application
  }, {
    content: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createVNode(_component_PatientDocuments, {
          "patient-id": _ctx.referral.id,
          application: _ctx.referral.application,
          "provider-id": _ctx.referral.providerId,
          "account-id": _ctx.referral.accountId,
          "upload-document": _ctx.uploadDocument,
          "delete-document": _ctx.deleteDocument,
          "get-documents": _ctx.getReferralDocuments,
          "is-palliative": _ctx.isPalliative,
          "is-referral-page": true,
          referral: _ctx.referral
        }, null, 8 /* PROPS */, ["patient-id", "application", "provider-id", "account-id", "upload-document", "delete-document", "get-documents", "is-palliative", "referral"]),
        _createElementVNode("footer", _hoisted_2, [
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeAddDocumentsDialog())),
            type: "button",
            class: "btn btn-xs me-2 btn-outline-primary"
          }, " Close ")
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["title", "application-id"]))
}